import styled from 'styled-components';
const H4 = styled.h4`
  font-size:2em;
  padding:2px 0;
  margin:3px 0;
  align-self:flex-start;
  color: var(--primary-color)!important;
`;
const TableSection = styled.div`
  width:100%;
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  margin:40px 0;
  @media (max-width: 1000px) {
    overflow-x:auto;
  }
 
`;
const TableIconButton = styled.button`
  padding: 5px;
  margin:2px;
  background-color:  var(--secondary-color);
  color: var(--font-on-secondary-color);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  font-size: 13px;
  &:hover {
    background-color: var(--secondary-hover-color);
  }
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  background-color: var(--primary-color);
  color: var(--font-on-primary-color);
  font-weight:300;
  padding: 10px;
  text-align: left;
`;

const Td = styled.td`
  border: 1px solid #ccc;
  padding: 10px;
  color: var(--font-on-background-color);
`;

const Tr = styled.tr`
  &:nth-child(even) {
    background-color: rgba(68, 70, 84, 0.1);
  }
`;
export {H4,TableSection,Table,Th,Td,Tr,TableIconButton};